export default "__VITE_ASSET__oNlJCxUt__"